// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"5255c9f2","712":"771176bf"}[chunkId] + ".chunk.js";
};